import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { NgxSpinnerService } from 'ngx-spinner';
import { APIService } from 'src/app/api.service';
import { DataService } from 'src/app/services/data.service';
import { CommonService } from 'src/app/services/common.service';
import { MultipleSelectItemComponent } from '../../inventory/multiple-select-item/multiple-select-item.component';

@Component({
  selector: 'app-project-type-entry',
  templateUrl: './project-type-entry.component.html',
  styleUrls: ['./project-type-entry.component.scss']
})
export class ProjectTypeEntryComponent implements OnInit {

  projectType: any = {
    id: 0,
    name: '',
    code: '',
    categoryID: 0,
    subCategoryID: 0,
    stages: [],
    BOM: []
  };
  codeChange: boolean = false;
  newStage: string = '';
  isEdit: boolean = false;
  projectTypeID: number = 0;
  jarvisData: any = [];
  agencyData: any = [];
  mdlRef: any;
  modalReference: any;
  stockItems: any = [];
  isEditStage: boolean = false;
  editStageIndex: number = -1;

  constructor(private apiService: APIService, private modalService: NgbModal, private dataService: DataService, private commonService: CommonService, private spinner: NgxSpinnerService) { }

  ngOnInit(): void {

    let agencyData = this.apiService.getCookie("M");
    if (agencyData) {
      this.agencyData = JSON.parse(agencyData);
    }
    let jarvis = this.apiService.getCookie("Jarvis");
    if (jarvis) {
      this.jarvisData = JSON.parse(jarvis);
    };

    this.dataService.items.subscribe((value) => {
      if (value.length > 0) {
        let tempData =  this.projectType.BOM.filter((x:any) => x.ItemID == value[0].ItemID)
        if(tempData.length == 0) {
         let selecetdItems = value;
         for (let i = 0; i < selecetdItems.length; i++) {
           this.projectType.BOM.push({
             ItemID: selecetdItems[i].ItemID,
             ReqdQty: '',
             TypeID: 1,
             Unit: selecetdItems[i].SKU,
             productName: selecetdItems[i].ItemName,
             productCode: selecetdItems[i].ItemCode,
             SKUPrecision: selecetdItems[i].SKUPrecision
           });
         }
        }
      }
    });
    
    if (this.isEdit && this.projectTypeID != 0) {
      this.getDetails();
    }
  }

  updateCode(): void {
    if (String(this.projectType.name).length < 30 && !this.codeChange) {
      this.projectType.code = this.projectType.name
    }
  }

  toggleCodeChange(): void {
    if (String(this.projectType.code).length > 4) {
      this.codeChange = true;
    }
  }

  addStage(): void {
    if (this.newStage == '') {
      this.apiService.successAlert('Please add stage name.');
      return;
    }

    const stage = {
      SID: Math.max(0, ...this.projectType.stages.map((obj: any) => Number(obj.SID? obj.SID : "0"))) + 1,
      SNm: this.newStage,
      UIDs: this.jarvisData[0].UserID,
      Seq: Math.max(0, ...this.projectType.stages.map((obj: any) => Number(obj.Seq? obj.Seq : "0"))) + 1,
      TID: 2
    }
    this.projectType.stages.push(stage);
    this.newStage = '';
    document.getElementById('inputAddStageWeb')?.focus();
    document.getElementById('inputAddStage')?.focus();
  }

  removeStage(index: number): void {
    this.projectType.stages.splice(index, 1);
  }

  toggleEditStage(index: number, show: boolean): void {
    this.isEditStage = show;
    this.editStageIndex = show ? index : -1;
  }

  clearAddStage(): void {
    this.newStage = '';
    document.getElementById('inputAddStageWeb')?.focus();
    document.getElementById('inputAddStage')?.focus();
  }

  removeMaterial(index: number): void {
    this.projectType.BOM.splice(index, 1);
  }

  prcisionCheck(material: any) {
    material.ReqdQty = this.commonService.PrecisionwiseValue(String(material.ReqdQty), material.SKUPrecision);
  }

  openItemSelect(): void {
    this.modalReference = this.modalService.open(MultipleSelectItemComponent, { windowClass : "itemSelectionModalClass", backdrop: 'static' });
    this.modalReference.componentInstance.typeID = 0; 
    this.modalReference.componentInstance.it = 0;
    this.modalReference.componentInstance.st = 0; 
    this.modalReference.componentInstance.rm = 0;     
    this.modalReference.componentInstance.ft = 0; 
    this.modalReference.componentInstance.mdlRef = this.modalReference;
  }

  save(): void {

    if (this.projectType.name == '') {
      this.apiService.successAlert('Please enter name.');
      return;
    }

    if (this.projectType.code == '') {
      this.apiService.successAlert('Please enter code.');
      return;
    }

    let BOM: any = [];
    let isInvalidBOM = false;
    if (this.projectType.BOM.length > 0) {
      this.projectType.BOM.forEach((material: any) => {
        BOM.push({
          ItemID: material.ItemID,
          ReqdQty: material.ReqdQty,
          TypeID: material.TypeID,
          Unit: material.Unit
        });
        if (material.ReqdQty == 0) {
          isInvalidBOM = true;
        }
      });
    }

    if (isInvalidBOM) {
      this.apiService.successAlert('Please enter material quantity more then zero.');
      return;
    }
    
    let MyLastSyncDT = localStorage.getItem("MyLastSyncDT");
    var tempData = [{
      'ItemID': this.projectType.id,
      'ItemName': this.projectType.name,
      'ItemCode': this.projectType.code,
      'TypeID': 6,
      'Details': '',
      'CategoryID': this.projectType.categoryID,
      'SubCategoryID': this.projectType.subCategoryID,
      'ISMade': true,
      'IsPurchased': false,
      'category': '',
      'CurrQty': 0,
      'SKU': 'no.s',
      'DefPurchRate': 0,
      'DefSaleRate': 0,
      'DefStockRate': 0,
      'MinStockQty': 0,
      'IsAvailable': true,
      'IsActive': true,
      'ImportanceID': 0,
      'HSNID': 0,
      'HSN': '',
      'ShowOnline': true,
      'BrochureLink': '',
      'photos': '',
      'Tags': '',
      'LeadTime': 0,
      'storeBatches': '[]',
      'CurrStoreID': 1,
      'HsnNo': '',
      'IGSTRate': 0,
      'InternalNotes': '',
      'BatchType': 0,
      'Batches': '[]',
      'categoryRates': '[]',
      'mrpRate': 0,
      'mrpPrice': 0,
      'stages': JSON.stringify(this.projectType.stages),
      'BOM': JSON.stringify(BOM),
      'itemType': 'P'   // Project Types
    }]
    let myParams = [{
      myUserID: this.jarvisData[0].UserID,
      myToken: this.jarvisData[0].WebToken,
      forAgencyID: this.jarvisData[0].AgencyIDs,
      myAgencyIDs: this.jarvisData[0].AgencyIDs,
      myLastSyncDT: MyLastSyncDT,
      isWeb: true,
      ForERPAgencyID: this.agencyData[0].ERPAgencyID,
      actionType: 'set',
      moduleID: 5,
      data: JSON.stringify(tempData)
    }];
    this.spinner.show();
    this.apiService.sendChange(myParams, this.successSave.bind(this), this.failureSave.bind(this));
  }

  successSave(res: any): void {
    this.spinner.hide();
    if (res.error) {
    }
    else {
      if (res) {
        var reponseData = JSON.parse(res.updatePackage);
        if(reponseData.Table[0].ErrCode == 1) {
          this.apiService.successAlert(reponseData.Table[0].ErrMsg);
        }
        else {
          let doneObj = {
            action: 'Done'
          }
          this.closeModel(doneObj);
          this.apiService.successAlert(`Product Type ${this.isEdit ? 'updated' : 'added'}.`);
        }
      }
    }
  }

  failureSave(res: any): void {
    this.spinner.hide();
    if (res.error) {
    }
    else {
      this.apiService.successAlert(res.message);
    }
  }

  getDetails(): void {
    let data = [{
      productID: this.projectTypeID
    }]

    let myParams = [{
        myUserID: this.jarvisData[0].UserID,
        myToken: this.jarvisData[0].WebToken,
        forAgencyID: this.jarvisData[0].AgencyIDs,
        myAgencyIDs: this.jarvisData[0].AgencyIDs,
        myLastSyncDT: null,
        isWeb: true,
        ForERPAgencyID: this.agencyData[0].ERPAgencyID,
        actionType: 'get',
        moduleID: 4,
        data: JSON.stringify(data)
    }];

    return this.apiService.getData(myParams, this.successGetDetails.bind(this), this.failureGetDetails.bind(this));
  }

  successGetDetails(res: any): void {
    this.spinner.hide();
    if (res.error) {
    }
    else {
      if (res) {
        var reponseData = JSON.parse(res.updatePackage);
        if(reponseData.Table[0].ErrCode == 1) {
          this.apiService.successAlert(reponseData.Table[0].ErrMsg);
        }
        else {
          const data = reponseData.Table[0];

          this.projectType.id = data.ItemID;
          this.projectType.name = data.ItemName;
          this.projectType.code = data.ItemCode;
          this.projectType.categoryID = data.CategoryID;
          this.projectType.subCategoryID = data.SubCategoryID;
          this.projectType.stages = data.StageFlow ? JSON.parse(data.StageFlow) : [];
          data.BOM = data.BOM ? JSON.parse(data.BOM) : [];
          data.BOM.forEach((material: any) => {
            const item = this.stockItems?.find((item: any) => item.ItemID == material.IID)
            
            this.projectType.BOM.push({
              ItemID: material.IID,
              ReqdQty: material.Qty,
              TypeID: 1,
              Unit: item?.SKU,
              productName: item?.ItemName,
              productCode: item?.ItemCode,
              SKUPrecision: item?.SKUPrecision
            })
          });
        }
      }
    }
  }

  failureGetDetails(res: any): void {
    this.spinner.hide();
    if (res.error) {
    }
    else {
      this.apiService.successAlert(res.message);
    }
  }

  resetProjectType(): void {
    this.projectType.id = 0;
    this.projectType.name = '';
    this.projectType.code = '';
    this.projectType.categoryID = 0;
    this.projectType.subCategoryID = 0;
    this.projectType.stages = [];
    this.projectType.BOM = [];
  }

  closeModel(obj: any): void {
    this.dataService.updateItems([]);
    this.resetProjectType();
    this.mdlRef.close(obj);
  }
}
